import { makeStyles, TextField } from '@material-ui/core';
import React from 'react';
import { getIn } from 'formik';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: props => ({
    minWidth: 220,
    '& input': {
      background: 'transparent',
    },
  }),
}));

const FormTextField = React.forwardRef((props, ref) => {
  const {
    form,
    field,
    autoFocus,
    disabled,
    label,
    helperText,
    multiline,
    rows,
    variant,
    type,
    endAdornment,
    setDirty,
  } = props;
  
  const componentMeta = form.getFieldMeta(field.name);
  const componentDisabled = disabled || form.isSubmitting;
  const componentError = componentMeta.touched && (getIn(form.errors, field.name) || getIn(form.status, field.name));
  const componentHelperText = (componentError && componentMeta.error) || helperText;
  const inputProps = { InputProps: { endAdornment: endAdornment } };
  const isUpdated = (componentMeta.initialValue !== componentMeta.value) && form.dirty;
  const styles = useStyles({ isUpdated: isUpdated });
  
  function getTextFieldClassName(isUpdated, isDisabled, type) {
    return classNames({
      isUpdated: isUpdated,
      isDisabled: isDisabled,
      [type]: type !== undefined,
    });
  }
  
  React.useEffect(() => {
    setDirty?.(isUpdated);
  }, [isUpdated, setDirty]);
  
  return (
    <TextField
      {...inputProps}
      ref={ref}
      type={type ? type : 'text'}
      variant={variant ? variant : 'outlined'}
      margin="normal"
      classes={styles}
      className={getTextFieldClassName(isUpdated, componentDisabled, type)}
      name={field.name}
      value={(field.value || field.value === 0) ? field.value : ''}
      onBlur={field.onBlur}
      onChange={field.onChange}
      onWheel={e => e.target instanceof HTMLElement && e.target.blur()}
      autoFocus={autoFocus}
      label={label}
      multiline={multiline}
      rows={rows}
      disabled={componentDisabled}
      error={!!componentError}
      helperText={componentHelperText}
    />
  );
});

export default FormTextField;
